import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { ClaimType } from '@constants';
import { isUserMobile } from '../utils';

// reference: https://fingerprint.com/github/
const fpPromise = FingerprintJS.load();
let cachedFingerprint = null;
// Get the visitor identifier when you need it.
export const getFingerprint = async () => {
  if (cachedFingerprint) {
    return Promise.resolve(cachedFingerprint);
  }
  return new Promise((resolve, reject) => {
    fpPromise
      .then((fp) => fp.get())
      .then((result) => {
        cachedFingerprint = result;
        resolve(result);
      }).catch((err) => {
        reject(err);
      });
  });
};

export const reportEvent = async (eventName, { reportData = {}, url }) => {
  try {
    const { visitorId: did } = await getFingerprint();
    const body = {
      code: 'resolution-center-report',
      eventInfo: JSON.stringify({
        ...reportData,
        did,
        eventName,
        isMobile: isUserMobile(),
        productType: reportData.issueType === ClaimType.RA ? 'RA' : 'BP',
        eventTime: Date.now(),
      }),
      platform: '17track',
    };
    console.log('body', body);
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(body),
      headers: {
        'Content-Type': 'application/json',
      },
    }).catch((e) => {
      console.log('REPORT EVENT ERROR', e.message);
    });
  } catch (error) {
    console.log('REPORT EVENT ERROR', error.message);
  }
};
